import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn( ...inputs ) {
  return twMerge(clsx(inputs));
}

export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 500);
  };
};

/**
 * Returns an array with an element moved from one index to another.
 * 
 * @param {array} array 
 * @param {int} fromIndex 
 * @param {int} toIndex 
 * @returns {array}
 */
export const moveItemInArray = (array, fromIndex, toIndex) => {
  const item = array[fromIndex];
  const arrayWithoutItem = array.toSpliced(fromIndex, 1);
  const newArray = arrayWithoutItem.toSpliced(toIndex, 0, item);
  return newArray;
}
